<template>
  <div class="creditForm">
    <img class="creditForm__brand" height="24" src="/static/img/ulmar/credit_brand.png" alt="card">
    <form-credit-card
      label="カード番号"
      name="ccNumber"
      placeholder="1234 5678 9123 4567"
      :value="input.ccNumber"
      @input="changeInput($event, 'ccNumber')"
      :validation="{ rules: { required: true, credit_card: true } }"
    ></form-credit-card>

    <form-credit-expire
      name
      label="カード有効期限"
      design-type="ulmar"
      month-name="cc_expiration_m"
      year-name="cc_expiration_y"
      :value="input.ccExpiration"
      @input="changeInput($event, 'ccExpiration')"
      :validation="{ rules: { required: true } }"
    ></form-credit-expire>

    <!-- <form-select
      name="number_payments"
      label="支払い回数"
      :value="input.numberPayments"
      @input="changeInput($event, 'numberPayments')"
      :options="option.numberPayments"
      :validation="{ rules: { required: true,} }"
    ></form-select> -->

    <div class="securityCode">
      <form-label label="セキュリティコード"></form-label>
      <div class="securityCode__question" @click="openAboutSecurityCode">
        <img width="16" height="16" src="/static/img/ulmar/question.svg">
      </div>
      <form-input
        name="security_code"
        type="tel"
        input-width="72px"
        maxlength="4"
        placeholder="1234"
        :value="input.securityCode"
        @input="changeInput($event, 'securityCode')"
        :validation="{ rules: { required: true, numeric: true, max: 4 } }"
      ></form-input>
      <div class="securityCode__about media" :data-visible="showAboutSecurityCode">
        <div class="media__image">
          <img src="/static/img/security-code.png" width="48" height="30">
        </div>
        <div class="media__content">
          <p>セキュリティコードはカード裏面に記載されている３桁または、表面に記載されている４桁の番号です。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormLabel from '@/utvStore/components/forms/FormLabel'

export default {
  name: 'CreditCardForm',
  components: {
    FormLabel,
  },
  props: {
    input: Object,
    option: Object,
  },
  data() {
    return {
      // セキュリティコードの説明の表示
      showAboutSecurityCode: false,
    }
  },
  watch: {
    input: {
      handler() {
        // changeInput で errors 渡すとずれるのでこのタイミングで errors だけ渡す
        // 原因：子→親→子 でデータの受け渡しがあるから。changeInput で親に渡す時点ではエラーなくても、子に戻してからエラーになる。
        this.$emit('error', this.errors.all().length)
      },
      deep: true
    },
    errors: {
      handler() {
        // ↑のinput の watch だけではきちんと error を判別できない時があったので、これも追加して２重でエラーチェック
        this.$emit('error', this.errors.all().length)
      },
      deep: true,
    },
  },
  methods: {
    // セキュリティコードの説明を表示
    openAboutSecurityCode() {
      this.showAboutSecurityCode = !this.showAboutSecurityCode
      if (this.showAboutSecurityCode) {
        setTimeout(this.openAboutSecurityCode, 5000)
      }
    },
    // 親に変更を送る
    changeInput($event, target) {
      this.$emit('change', { target: target, value: $event })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/commons/commonVariables.scss';
.creditForm {
  &__brand {
    width: 106px;
    height: auto;
    margin: 0 0 16px;
  }
  .formGroup {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  /deep/ {
    .form-label__label {
      font-size: 11px;
      font-weight: 400;
      color: inherit;
    }
    .formControl,
    .form-input__input {
      border-color: #EEEEEE;
      border-radius: 8px;
      font-size: 15px;
      color: inherit;
      font-family: inherit !important;
      &::placeholder {
        color: #D1DDE4;
      }
      &[type='tel']:not(:placeholder-shown),
      &.selected {
        border-color: #B1816D;
      }
      &[data-error='true'],
      &--error {
        background: inherit !important;
        border-color: #FF6767 !important;
      }
    }
    select.formControl {
      width: 72px;
      margin-right: 16px;
      background-image: url(/static/img/ulmar/arrow_down.svg);
    }
    .formGroup__errorMessage,
    .form-input__error-message {
      color: #FF6767;
      font-size: 10px;
      font-weight: 400;
      line-height: 15px;
    }
  }
}
.securityCode {
  position: relative;
  .form-label {
    display: inline-block;
  }
  &__question {
    display: inline-block;
    cursor: pointer;
    vertical-align: -1px;
    img {
      vertical-align: middle;
    }
  }
  &__about {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    border-radius: 4px;
    left: 120px;
    top: 0;
    align-items: center;
    pointer-events: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    &[data-visible='true'] {
      opacity: 1;
      pointer-events: auto;
    }
    .media__content p {
      font-size: 10px;
      line-height: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Ulmar/partials/CreditCardForm.vue